import { useEffect, useState } from 'react';
import { FiArrowRight } from "react-icons/fi";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { getAllProducts } from '../../../../api/action/products';
import FlexOfficeFooter from '../components/FlexOfficeFooter';
import FlexOfficeHeader from '../components/FlexOfficeHeader';

const TypeBasedFilter = () => {
    const [categoryProducts, setCategoryProducts] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const companyPrimaryId = useSelector((state) => state.companyReducer.company?.primaryId) || '';
    const location = useLocation();
    const primaryId = location.state?.primaryId;
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = companyPrimaryId ? await getAllProducts(companyPrimaryId)(dispatch) : [];
                const filteredProducts = response.filter(product => product.category?.primaryId === primaryId);
                setCategoryProducts(filteredProducts);
            } catch {
                setCategoryProducts([]);
            }
        };
        fetchProducts();
    }, [companyPrimaryId, dispatch, primaryId]);

    const displayedProducts = categoryProducts.slice(0, 4);

    const handleViewAllClick = () => {
        navigate('/services');
    };

    const handleView = (product) => {
        navigate('/view-service', { state: { primaryId: product.primaryId, product } });
    };

    return (
        <>
            <FlexOfficeHeader />
            <div className="fx-m-hide"><br /><br /></div>
            <section className="py-16 bg-gradient-to-br from-slate-50 via-white to-blue-50/30">
                <div className="container mx-auto px-6 fx-m-page">
                    {/* Back Button and View All */}
                    <div className="flex justify-between items-center mb-8">
                        <button
                            onClick={() => navigate(-1)}
                            className="text-slate-600 hover:text-slate-800 flex items-center transition-all duration-300"
                        >
                            ← Back
                        </button>
                        <button
                            onClick={handleViewAllClick}
                            className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2"
                        >
                            <span>View All</span>
                            <FiArrowRight className="w-5 h-5" />
                        </button>
                    </div>

                    {/* Page Title */}
                    <h2 className="text-3xl sm:text-4xl font-bold text-center text-slate-800 mb-12">
                        Our Services
                    </h2>

                    {/* Product Grid */}
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 fx-m-grid-1">
                        {displayedProducts.map((product) => (
                            <div
                                key={product.primaryId}
                                className="bg-white shadow-lg border border-slate-200 overflow-hidden rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                            >
                                <img
                                    src={product?.imageContents?.[0]?.displayLink || "https://via.placeholder.com/400x250"}
                                    alt={product.name}
                                    className="w-full h-56 object-cover rounded-t-2xl"
                                />
                                <div className="p-6">
                                    <h3 className="text-xl font-semibold text-slate-800">{product.name}</h3>
                                    <p className="text-slate-600 mt-2">{product.category.name}</p>
                                    <div className="mt-4 flex flex-col space-y-2">
                                        <button
                                            onClick={() => handleView(product)}
                                            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl"
                                        >
                                            View Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* View All Button at Bottom */}
                    {categoryProducts.length > 4 && (
                        <div className="mt-12 text-center">
                            <button
                                onClick={handleViewAllClick}
                                className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl"
                            >
                                View All Services
                            </button>
                        </div>
                    )}
                </div>
            </section>
            <FlexOfficeFooter />
        </>
    );
};

export default TypeBasedFilter;
